import { POPUP_ACTIONS } from './types';

const initialState = {
    configId: null,
    currentView: null,
    currentConfig: null
};

const reducer = (state = initialState, action = { type: null }) => {
    switch (action.type) {
        case POPUP_ACTIONS.INIT:
            return {
                currentView: action.data.currentView,
                currentConfig: action.data.currentConfig
            };
        case POPUP_ACTIONS.OPEN:
            return {
                ...state,
                configId: action.data.configId,
                currentView: action.data.currentView,
                currentConfig: action.data.currentConfig
            };
        case POPUP_ACTIONS.CLOSE:
            return {
                ...state,
                configId: null,
                currentView: null,
                currentConfig: null
            };
        case POPUP_ACTIONS.SWITCH:
            return {
                ...state,
                currentView: action.data.view ? action.data.view : state.currentView
            };
        default:
            return state;
    }
};

export default reducer;
